/**
 * Block: Card-Slider
 * 
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-scripts/#build for build info.
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata for block.json information.
 * 
 */
import './card-slider.scss';
const cardSliderBlock = (id) => {
    const body = document.body;
    const module = document.getElementById(id);
    const cardSlider = module.querySelector('swiper-container');
    const modal = module.querySelector('.js-modal');
    const modalOpenButtons = module.querySelectorAll('.js-modal-open');
    const modalCloseButton = module.querySelector('.js-modal-close');
    const modalLogo = module.querySelector('.js-modal-logo');
    const modalName = module.querySelector('.js-modal-name');
    const modalVisit = module.querySelector('.js-modal-visit');
    const modalAddress = module.querySelector('.js-modal-address');
    const modalImg = module.querySelector('.js-modal-img');
    const modalTitle = module.querySelector('.js-modal-title');
    const modalDescription = module.querySelector('.js-modal-description');
    const modalAbout = module.querySelector('.js-modal-about');
    let scrollPosition = 0;

    const showOverlay = () => {
        const wpAdminBarHeight = document.getElementById('wpadminbar')?.offsetHeight || 0;
        scrollPosition = window.pageYOffset;
        body.style.top = (-scrollPosition + wpAdminBarHeight) + 'px';
        body.style.width = '100%';
        body.style.position = 'fixed';
    }

    const removeOverlay = () => {
        body.classList.remove('show-overlay');
        body.style.removeProperty('top');
        body.style.removeProperty('width');
        body.style.removeProperty('position');
        window.scrollTo(0, scrollPosition);
    }

    const setLocationData = (data) => {
        modalLogo && (modalLogo.src = data.logoImg);
        modalName && (modalName.innerHTML = data.title);
        modalAddress && (modalAddress.innerHTML = `${data.address1}, ${data.address2}`);
        modalImg && (modalImg.src = data.modalImg);
        modalTitle && (modalTitle.innerHTML = data.modalTitle);
        modalDescription && (modalDescription.innerHTML = data.modalDescription);
        modal?.classList.add('visible');
        showOverlay();
    }

    const setSolutionData = (data) => {
        modalLogo && (modalLogo.src = data.logoImg);
        modalName && (modalName.innerHTML = data.title);
        modalDescription && (modalDescription.innerHTML = data.modalDescription);
        modalImg && (modalImg.src = data.modalImg);
       
        modalVisit && (
            // console.log(data.websiteUrl, data.title),
            modalVisit.href = data.websiteUrl,
            modalVisit.textContent = `Visit ${data.title}`
        )
        modalTitle && (modalTitle.innerHTML = data.modalTitle);
        modalAbout && (modalAbout.innerHTML = data.modalAbout);
        modal?.classList.add('visible');
        showOverlay();
    }

    modalOpenButtons.forEach((button) => {
        button.addEventListener('click', ({currentTarget}) => {
            const {type, ...rest} = currentTarget.dataset;

            if(type === 'location') {
                setLocationData(rest);
            }

            if(type === 'solution') {
                setSolutionData(rest);
            }
        });
    });

    modalCloseButton?.addEventListener('click', () => {
        modal?.classList.remove('visible');
        removeOverlay();
    });

    window.onclick = function(event) {
        if (event.target == modal) {
            modal?.classList.remove('visible');
            removeOverlay();
        }
    }

    Object.assign(cardSlider, {
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 24,
        breakpoints: {
            500: {
                slidesPerView: 2,
                spaceBetween: 24
            },
            575: {
                slidesPerView: 2,
                spaceBetween: 32
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            992: {
                slidesPerView: 2.9,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 48,
            },
            1320: {
                slidesPerView: 3.1,
                spaceBetween: 48,
            },
        },
        navigation: {
            nextEl: module.querySelector('.js-next'),
            prevEl: module.querySelector('.js-prev')
        },
    });

    cardSlider?.initialize();
}

window.cardSliderBlock = cardSliderBlock;